import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { Col, Row, Button } from "react-bootstrap";
import ReactTable from "react-table";
import debounce from "lodash/debounce";
import moment from "moment";
import ProjectsService from "../../../services/ProjectsService"; 
import ExportService from "../../../services/ExportService";
import HandleError from "../../../services/HandleError";
import Materialicon from "../../helpers/Materialicon";
import { minutesToHourAndMinutes } from "../../helpers/HelperFunctions";

class ProjectsDetailsPage extends Component {
	state = {
		isLoadingTable: false,
		data: [],
		pages: 1,
	}

	getProjectsDetails= (state) => {
		const {pageSize, sorted, filtered, page } = state;
		const data = JSON.stringify({pageSize, sorted, filtered, page});
		this.setState({ isLoadingTable: true});
		new ProjectsService(this,"/info").index(page+1, `data=${data}`).then((res) => {
			this.setState({ isLoadingTable:false, data: res.data.data, pages: res.data.last_page, pageState: state});
		}).catch((err) => {
			this.setState({isLoadingTable:false});
			HandleError(err,this);
		});
	}

	exportToExcel = () => {
		const state = this.state.pageState;
		const page = this.state.pageState.page + 1;
		const data = JSON.stringify({
			pageSize: state.pageSize,
			sorted: state.sorted,
			filtered: state.filtered
		});
		new ExportService().exportToExcel("projects/export-info-all", page, data);
	}

	render() {
    	const { data, isLoadingTable, pages } = this.state;
    	return (
    		<div className="crud-page customers-page">
    			<div className="container-fluid">
    				<section className="actions">
    					<Row>
    						<Col md={6} sm={6} xs={12}>
    							<h2 className="page-title">Project details</h2>
    						</Col>
    						<Col md={6} sm={6} xs={12}>
    							<Link to="/projects" className="pull-right btn-add-big btn btn-default">
    								<Materialicon icon="keyboard_arrow_left" /> Back to projects
    							</Link>
    						</Col>
    					</Row>   
    				</section>
    				<div className="card card-top-border connection-card fadeInLoadUp">
						<Row>
							<Col md={12}>
								<Button bsStyle="primary" className="btn-min btn-crud btn-export" onClick={this.exportToExcel}>Export</Button>
							</Col>
						</Row>
    					<ReactTable
    						columns={[
    							{
    								Header: "Name",
    								accessor: "name",
    								Cell: row => <div className="text-center"><Link to={`/projects/${row.original.id}/info`} className="text-center">{row.value}</Link></div>,
    								minWidth: 250
    							}, 
    							{
    								Header: "Budget",
    								accessor: "budget",
    								Cell: row => <div className="text-center">{row.value !==null ? `${row.value}€` : "-"}</div>,
    								minWidth: 100
    							}, {
    								Header: "Costs",
    								accessor: "total_cost",
									Cell: row => <div className="text-center">{row.value !==null ? `${row.value}€` : "-"}</div>,
    								minWidth: 100
    							}, {
    								Header: "Benefits",
    								accessor: "benefit",
									Cell: row => <div className="text-center">{row.value !==null ? `${row.value}€` : "-"}</div>,
									minWidth: 100
								},
								{
    								Header: "Date created",
    								accessor: "created_at",
    								Cell: row => (<div className="text-center">{moment(row.value).format("DD-MM-YYYY")}</div>),
    								minWidth: 150
								},
								{
    								Header: "Deadline",
    								accessor: "deadline",
    								Cell: row => (<div className="text-center">{moment(row.value).format("DD-MM-YYYY")}</div>),
    								minWidth: 150
								},
								{
    								Header: "Total Hours",
    								accessor: "time",
    								filterable: false,
    								sortable: false,
    								Cell: (row) => {
    									const {hours, minutes} = minutesToHourAndMinutes(row.value);
    									return (
    										<div className="text-center"> 
    											{ hours > 0 ? `${hours}h` : `${0}h`} { minutes > 0 ? ` and ${minutes}min` : null}
    										</div>
    									);
    								}
    							},
								{
    								Header: "Total fixed costs",
    								accessor: "fixed_costs_cost",
									Cell: row => <div className="text-center">{row.value > 0 ? row.value : 0}€</div>,
    								minWidth: 150
								},
								{
    								Header: "Total employees cost",
    								accessor: "logging_hours_cost",
    								Cell: row => <div className="text-center">{row.value > 0 ? row.value : 0}€</div>,
    								minWidth: 150
								},
								{
    								Header: "Status",
    								accessor: "status",
    								Cell(row) {
    									switch(row.value) {
    									case "Active":
    										return <div className="text-center"><span className="status status-in-progress">Active</span></div>;
    									case "NotActive":
    										return <div className="text-center"><span className="status status-inactive">Inactive</span></div>;
    									case "StandBy":
    										return <div className="text-center"><span className="status status-to-do">StandBy</span></div>;
    									case "Finished":
    										return <div className="text-center"><span className="status status-done">Finished</span></div>;
    									default:
    										return <div className="text-center"><span className="status status-default">{row.value}</span></div>;
    									}
    								}
								},
    							
    						]}
    						manual 
    						data={data}
    						pages={pages} 
    						loading={isLoadingTable}
    						onFetchData={ debounce(this.getProjectsDetails, 200) } 
    						filterable
    						defaultSorted={[{ id: "created_at", desc: true }]}
    						defaultPageSize={20}
    						className="-highlight"
    					/>
    				</div>   
    			</div>
    		</div>
    	);
	}
}

export default ProjectsDetailsPage;




// WEBPACK FOOTER //
// ./src/components/pages/projects/ProjectsDetailsPage.js